<template>
  <b-modal ref="modal" size="md" hide-footer centered @shown="onShown" @hidden="onHidden">
    <template v-slot:modal-title>
      <i class="ion ion-md-lock text-warning"></i>
      {{ resolvedTitle }}
    </template>
    <div class="text-center mb-3">
      <p class="mb-3" v-html="message"></p>
      <div class="form-group">
        <label class="form-label font-weight-bold">
          {{ resolvedCodeLabel }}
          <span class="text-danger">*</span>
        </label>
        <b-form-input
          ref="mfaInput"
          class="totp-pass-input text-center"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          maxlength="6"
          :value="normalizedValue"
          :placeholder="resolvedPlaceholder"
          :disabled="loading"
          required
          @input="onInput"
          @keypress="onlyNumbers"
          @keyup.enter="onConfirm"
        />
        <small class="form-text text-muted">
          {{ resolvedHelperText }}
        </small>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-4">
      <b-button @click="$emit('cancel')" :disabled="loading" class="mr-2">
        {{ resolvedCancelLabel }}
      </b-button>
      <b-button variant="primary" @click="onConfirm" :disabled="isConfirmDisabled">
        <b-spinner small v-if="loading" class="mr-1"></b-spinner>
        {{ loading ? resolvedLoadingLabel : resolvedConfirmLabel }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalConfirmacaoMfa',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    codeLabel: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    helperText: {
      type: String,
      default: null
    },
    cancelLabel: {
      type: String,
      default: null
    },
    confirmLabel: {
      type: String,
      default: null
    },
    loadingLabel: {
      type: String,
      default: null
    }
  },
  computed: {
    normalizedValue() {
      return `${this.value || ''}`;
    },
    isConfirmDisabled() {
      return !this.normalizedValue || this.normalizedValue.length !== 6 || this.loading;
    },
    resolvedTitle() {
      return this.title || this.$t('Autenticação Necessária');
    },
    resolvedCodeLabel() {
      return this.codeLabel || this.$t('Código de verificação em duas etapas');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('Digite o código MFA');
    },
    resolvedHelperText() {
      return this.helperText || this.$t('Digite o código de 6 dígitos do seu aplicativo autenticador');
    },
    resolvedCancelLabel() {
      return this.cancelLabel || this.$t('Cancelar');
    },
    resolvedConfirmLabel() {
      return this.confirmLabel || this.$t('Confirmar');
    },
    resolvedLoadingLabel() {
      return this.loadingLabel || this.$t('Processando...');
    }
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onShown() {
      this.$nextTick(() => {
        if (this.$refs.mfaInput) {
          this.$refs.mfaInput.focus();
        }
      });

      this.$emit('shown');
    },
    onHidden() {
      this.$emit('hidden');
    },
    onInput(value) {
      const parsed = `${value || ''}`.replace(/[^0-9]/g, '').slice(0, 6);

      this.$emit('input', parsed);

      this.$nextTick(() => {
        if (this.$refs.mfaInput && this.$refs.mfaInput.$el) {
          this.$refs.mfaInput.$el.value = parsed;
        }
      });
    },
    onlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    onConfirm() {
      this.$emit('confirm');
    }
  }
};
</script>

<style scoped>
.totp-pass-input {
  font-size: 30px;
  letter-spacing: 15px;
  text-align: center;
}

.totp-pass-input::placeholder {
  font-size: 14px;
  letter-spacing: normal;
}
</style>
